import React from 'react';
import { XIcon, CheckIcon } from 'lucide-react';
import { Reveal } from './Reveal';
const pathA = ['Seguir intentando “quemar” una inflamación que no se va con ejercicio', 'Culparte por una falta de voluntad que nunca fue el problema', 'Esperar a que tu cuerpo te duela para hacer un cambio', 'Envejecer aceleradamente por cortisol crónico', 'Pasar otro año viéndote en el espejo y no reconocerte'];
const pathB = ['Invertir $15,90 (menos que una comida rápida) por la llave maestra de tu metabolismo', 'Descubrir los 7 días que cambian cómo tu cuerpo procesa el estrés', 'Volverte imbatible al cortisol', 'Recuperar tu rostro, tu energía y tu confianza', 'Terminar 2026 como una versión de ti que reconoces en el espejo'];
export function Closing() {
  return <section className="w-full bg-bark py-16 text-cream sm:py-24" aria-labelledby="cierre-title" data-id="element-18" data-mp="30e6jv5xietjf">
      <div className="mx-auto max-w-5xl px-5 sm:px-8" data-id="element-19" data-mp="uh16lp4b5762">
        <Reveal data-id="element-20" data-mp="yjpf1vp40c2i">
          <p className="text-xs font-semibold uppercase tracking-widest text-cream/50" data-id="element-21" data-mp="yk786jgh6a67">
            Los dos caminos
          </p>
          <h2 id="cierre-title" className="mt-4 max-w-2xl font-display text-3xl font-semibold leading-tight tracking-tight sm:text-[2.6rem]" data-id="element-22" data-mp="3qzmg0sq5my8l">
            Hoy puedes elegir
          </h2>
        </Reveal>

        <div className="mt-12 grid gap-5 lg:grid-cols-2" data-id="element-23" data-mp="3vspad32rabpu">
          <Reveal data-id="element-24" data-mp="3vt7fkp7ec09w">
            <div className="h-full rounded-2xl border border-cream/15 p-6 sm:p-8" data-id="element-25" data-mp="3vusawh1jbn8t">
              <span className="inline-flex h-9 w-9 items-center justify-center rounded-lg bg-cream/10 text-cream/70" data-id="element-26" data-mp="383mt3wc1akvv">
                <XIcon className="h-5 w-5" aria-hidden="true" data-id="element-27" data-mp="3364m4bhkufqi" />
              </span>
              <h3 className="mt-5 font-display text-xl text-cream/90" data-id="element-28" data-mp="3i2luquydtg9d">Camino A: cerrar esta página</h3>
              <ul className="mt-5 space-y-3" data-id="element-29" data-mp="3d0wi5aviguj6">
                {pathA.map(item => <li key={item} className="flex gap-3 text-sm leading-relaxed text-cream/60" data-id="element-30" data-mp="xa0j4wxkhbtt">
                    <XIcon className="mt-0.5 h-4 w-4 shrink-0 text-cream/40" aria-hidden="true" data-id="element-31" data-mp="scs0ywcf57sk" />
                    {item}
                  </li>)}
              </ul>
            </div>
          </Reveal>

          <Reveal delay={0.05} data-id="element-32" data-mp="14d8enhdnetwo">
            <div className="h-full rounded-2xl bg-cream p-6 text-bark sm:p-8" data-id="element-33" data-mp="14cf6cbz1jwcf">
              <span className="inline-flex h-9 w-9 items-center justify-center rounded-lg bg-sageDeep text-cream" data-id="element-34" data-mp="19eo03ajqn2fl">
                <CheckIcon className="h-5 w-5" aria-hidden="true" data-id="element-35" data-mp="1ebo6xnoew97r" />
              </span>
              <h3 className="mt-5 font-display text-xl" data-id="element-36" data-mp="gq8n0tk62u6w">Camino B: invertir hoy</h3>
              <ul className="mt-5 space-y-3" data-id="element-37" data-mp="lotoewb5njwx">
                {pathB.map(item => <li key={item} className="flex gap-3 text-sm leading-relaxed text-ink/85" data-id="element-38" data-mp="qn4zfad6s0gq">
                    <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-sageDeep" aria-hidden="true" data-id="element-39" data-mp="vdlf714hby69" />
                    {item}
                  </li>)}
              </ul>
            </div>
          </Reveal>
        </div>

        <Reveal data-id="element-40" data-mp="2wr1j37x77e8">
          <p className="mt-12 max-w-3xl font-display text-2xl leading-snug sm:text-3xl" data-id="element-41" data-mp="2w91dvi50911">
            Con la Garantía de 60 Días, no tienes nada que perder y una versión ligera, enérgica y
            definida que ganar.
          </p>
        </Reveal>
      </div>
    </section>;
}